// import React, { Fragment, useEffect, useState } from "react";
// import type { FC, PropsWithChildren } from "react";
// import TextBox from "./InputField.module.css";

// type InputBoxProps = PropsWithChildren<{
//   className?: string;
//   icon?: string;
//   icon2?: string;
//   type?: string;
//   value: string;
//   label?: string;
//   locked?: boolean;
//   labelStyle?: React.CSSProperties;
//   placeholderstyle?: React.CSSProperties;
//   disabled?: boolean;
//   placeholder?: string;
//   errorMessage?: string;
//   defaultValue?: string;
//   style?: React.CSSProperties;
//   onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
//   onfocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
//   onClickIcon1?: React.MouseEventHandler<SVGSVGElement>;
//   onClickIcon2?: React.MouseEventHandler<SVGSVGElement>;
//   info_icon?: string;
//   info_description?: string;
//   customClass?: string;
//   inputCustomStyle?: React.CSSProperties;
//   containerClass?: string;
//   labelClass?: string;
//   errorClass?: string;
//   max?: string;
//   readOnly?: boolean;
//   allowFutureDates?: boolean;
//   inputRef?: React.RefObject<HTMLInputElement> | null;
// }>;

// const InputField: FC<InputBoxProps> = ({
//   info_description,
//   info_icon,
//   className,
//   type = "text",
//   placeholder,
//   value,
//   onChange,
//   onfocus,
//   errorMessage,
//   labelStyle,
//   placeholderstyle,
//   label,
//   icon,
//   icon2,
//   style,
//   disabled,
//   defaultValue,
//   locked,
//   onClickIcon1,
//   onClickIcon2,
//   customClass,
//   inputCustomStyle,
//   containerClass,
//   labelClass,
//   errorClass,
//   readOnly,
//   max,
//   allowFutureDates = false,
//   inputRef,
// }) => {
//   const [inputType, setInputType] = useState(type);
//   const [showTooltip, setShowTooltip] = useState(false);
//   const [localError, setLocalError] = useState("");

//   const handlePasswordView = () => {
//     if (type === "password") {
//       setInputType(inputType === "text" ? "password" : "text");
//     }
//   };

//   const getTodaysDate = () => {
//     const today = new Date();
//     const dd = String(today.getDate()).padStart(2, "0");
//     const mm = String(today.getMonth() + 1).padStart(2, "0");
//     const yyyy = today.getFullYear();
//     return `${yyyy}-${mm}-${dd}`;
//   };

//   const getMinDateOneMonthAgo = () => {
//     const date = new Date();
//     date.setMonth(date.getMonth() - 1);
//     const dd = String(date.getDate()).padStart(2, "0");
//     const mm = String(date.getMonth() + 1).padStart(2, "0");
//     const yyyy = date.getFullYear();
//     return `${yyyy}-${mm}-${dd}`;
//   };

//   useEffect(() => {
//     if (type === "date" && value) {
//       const selectedDate = new Date(value);
//       const today = new Date();
//       const oneMonthAgo = new Date();
//       oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

//       selectedDate.setHours(0, 0, 0, 0);
//       today.setHours(0, 0, 0, 0);
//       oneMonthAgo.setHours(0, 0, 0, 0);

//       if (label?.toLowerCase().includes("start")) {
//         if (selectedDate > today) {
//           setLocalError("Start date cannot be in the future");
//         } else if (selectedDate < oneMonthAgo) {
//           setLocalError("Start date cannot be more than 1 month in the past");
//         } else {
//           setLocalError("");
//         }
//       } else if (!allowFutureDates && selectedDate > today) {
//         setLocalError("Date cannot be in the future");
//       } else {
//         setLocalError("");
//       }
//     } else {
//       setLocalError("");
//     }
//   }, [value, type, allowFutureDates, label]);

//   return (
//     <div
//       className={`${TextBox.form_input} ${className || ""}`}
//       style={inputCustomStyle}
//     >
//       {label && (
//         <div style={{ display: "flex" }}>
//           <label
//             htmlFor={label}
//             className={`${TextBox.form_input__label} ${labelClass ?? ""}`}
//             style={labelStyle}
//           >
//             {label}
//           </label>
//           {info_icon && (
//             <div
//               className={TextBox.form_input__infoIcon}
//               onMouseEnter={() => setShowTooltip(true)}
//               onMouseLeave={() => setShowTooltip(false)}
//             >
//               <svg className={TextBox.form_input__icon}>
//                 <use xlinkHref={`/assets/sprite.svg#icon-info`} />
//               </svg>
//               {showTooltip && (
//                 <div className={TextBox.tooltip}>{info_description}</div>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       <div
//         className={`${TextBox.form_input__container} ${containerClass ?? ""}`}
//         style={style}
//       >
//         {icon && (
//           <svg className={TextBox.form_input__icon} onClick={onClickIcon1}>
//             <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
//           </svg>
//         )}
//         {icon2 && (
//           <svg className={TextBox.form_input__icon} onClick={onClickIcon2}>
//             <use xlinkHref={`/assets/sprite.svg#icon-${icon2}`} />
//           </svg>
//         )}
//         {!locked ? (
//           <Fragment>
//             <input
//               type={inputType}
//               id={label}
//               disabled={disabled ?? false}
//               placeholder={placeholder}
//               value={value}
//               style={placeholderstyle}
//               defaultValue={defaultValue}
//               onChange={onChange}
//               onFocus={onfocus}
//               readOnly={readOnly}
//               className={`${TextBox.form_input__box} ${customClass || ""}`}
//               {...(type === "date" && label?.toLowerCase().includes("start")
//                 ? {
//                     max: getTodaysDate(),
//                     min: getMinDateOneMonthAgo(),
//                   }
//                 : type === "date" && !allowFutureDates
//                 ? { max: getTodaysDate() }
//                 : {})}
//               ref={inputRef}
//             />
//             {type === "password" && (
//               <svg
//                 className={TextBox.form_input__icon}
//                 onClick={handlePasswordView}
//               >
//                 <use
//                   xlinkHref={`/assets/sprite.svg#icon-${
//                     inputType === "text" ? "visibility_off" : "visibility"
//                   }`}
//                 />
//               </svg>
//             )}
//           </Fragment>
//         ) : (
//           <Fragment>
//             <p
//               className={TextBox.form_input__box}
//               style={{
//                 height: "1.5rem",
//                 lineHeight: "1",
//                 color: value ? "var(--grey)" : "var(--light-grey)",
//               }}
//             >
//               {value ? value : placeholder}
//             </p>
//             <svg className={TextBox.form_input__icon}>
//               <use xlinkHref={`/assets/sprite.svg#icon-lock`} />
//             </svg>
//           </Fragment>
//         )}
//       </div>

//       {(errorMessage || localError) && (
//         <p className={`${TextBox.form_input__error} ${errorClass ?? ""}`}>
//           {localError || errorMessage}
//         </p>
//       )}
//     </div>
//   );
// };

// export default InputField;


import React, { Fragment, useEffect, useState } from "react";
import type { FC, PropsWithChildren } from "react";
import TextBox from "./InputField.module.css";

type InputBoxProps = PropsWithChildren<{
  className?: string;
  icon?: string;
  icon2?: string;
  type?: string;
  value: string;
  label?: string;
  locked?: boolean;
  labelStyle?: React.CSSProperties;
  placeholderstyle?: React.CSSProperties;
  disabled?: boolean;
  placeholder?: string;
  errorMessage?: string;
  defaultValue?: string;
  style?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onfocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClickIcon1?: React.MouseEventHandler<SVGSVGElement>;
  onClickIcon2?: React.MouseEventHandler<SVGSVGElement>;
  info_icon?: string;
  info_description?: string;
  customClass?: string;
  inputCustomStyle?: React.CSSProperties;
  containerClass?: string;
  labelClass?: string;
  errorClass?: string;
  max?: string;
  readOnly?: boolean;
  allowFutureDates?: boolean;
  inputRef?: React.RefObject<HTMLInputElement> | null;
}>;

const InputField: FC<InputBoxProps> = ({
  info_description,
  info_icon,
  className,
  type = "text",
  placeholder,
  value,
  onChange,
  onfocus,
  errorMessage,
  labelStyle,
  placeholderstyle,
  label,
  icon,
  icon2,
  style,
  disabled,
  defaultValue,
  locked,
  onClickIcon1,
  onClickIcon2,
  customClass,
  inputCustomStyle,
  containerClass,
  labelClass,
  errorClass,
  readOnly,
  max,
  allowFutureDates = false,
  inputRef,

}) => {
  const [inputType, setInputType] = useState(type);
  const [showTooltip, setShowTooltip] = useState(false);
  const [localError, setLocalError] = useState("");

  const handlePasswordView = () => {
    if (type === "password") {
      setInputType(inputType === "text" ? "password" : "text");
    }
  };

  const getTodaysDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  };

  const getMinDateOneMonthAgo = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    if (type === "date" && value) {
      const selectedDate = new Date(value);
      const today = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      oneMonthAgo.setHours(0, 0, 0, 0);

      if (label?.toLowerCase().includes("start")) {
        if (selectedDate > today) {
          setLocalError("Start date cannot be in the future");
        } else if (selectedDate < oneMonthAgo) {
          setLocalError("Start date cannot be more than 1 month in the past");
        } else {
          setLocalError("");
        }
      } else if (!allowFutureDates && selectedDate > today) {
        setLocalError("Date cannot be in the future");
      } else {
        setLocalError("");
      }
    } else {
      setLocalError("");
    }
  }, [value, type, allowFutureDates, label]);

   const disabledClass = disabled ? TextBox.disabled : '';

  return (
    <div
      className={`${TextBox.form_input} ${className || ""} ${disabledClass}`}
      style={inputCustomStyle}
    >
      {label && (
        <div style={{ display: "flex" }}>
          <label
            htmlFor={label}
            className={`${TextBox.form_input__label} ${labelClass ?? ""}`}
            style={labelStyle}
          >
            {label}
          </label>
          {info_icon && (
            <div
              className={TextBox.form_input__infoIcon}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <svg className={TextBox.form_input__icon}>
                <use xlinkHref={`/assets/sprite.svg#icon-info`} />
              </svg>
              {showTooltip && (
                <div className={TextBox.tooltip}>{info_description}</div>
              )}
            </div>
          )}
        </div>
      )}

      <div
        className={`${TextBox.form_input__container} ${containerClass ?? ""}`}
      
      >
        {icon && (
          <svg className={TextBox.form_input__icon} onClick={onClickIcon1}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
          </svg>
        )}
        {icon2 && (
          <svg className={TextBox.form_input__icon} onClick={onClickIcon2}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon2}`} />
          </svg>
        )}
        {!locked ? (
          <Fragment>
            <input
              type={inputType}
              id={label}
              disabled={disabled ?? false}
              placeholder={placeholder}
              value={value}
              style={{
                ...placeholderstyle,
                ...(disabled ? { color:  "var(--light-grey)"} : {}),
              }}
              defaultValue={defaultValue}
              onChange={onChange}
              onFocus={onfocus}
              readOnly={readOnly}
              className={`${TextBox.form_input__box} ${customClass || ""}`}
              {...(type === "date" && label?.toLowerCase().includes("start")
                ? {
                    max: getTodaysDate(),
                    min: getMinDateOneMonthAgo(),
                  }
                : type === "date" && !allowFutureDates
                ? { max: getTodaysDate() }
                : {})}
              ref={inputRef}
            />
            {type === "password" && (
              <svg
                className={TextBox.form_input__icon}
                onClick={handlePasswordView}
              >
                <use
                  xlinkHref={`/assets/sprite.svg#icon-${
                    inputType === "text" ? "visibility_off" : "visibility"
                  }`}
                />
              </svg>
            )}
          </Fragment>
        ) : (
          <Fragment>
            <p
              className={TextBox.form_input__box}
              style={{
                height: "1.5rem",
                lineHeight: "1",
                color: value ? "var(--grey)" : "var(--light-grey)",
              }}
            >
              {value ? value : placeholder}
            </p>
            <svg className={TextBox.form_input__icon}>
              <use xlinkHref={`/assets/sprite.svg#icon-lock`} />
            </svg>
          </Fragment>
        )}
      </div>

      {(errorMessage || localError) && (
        <p className={`${TextBox.form_input__error} ${errorClass ?? ""}`}>
          {localError || errorMessage}
        </p>
      )}
    </div>
  );
};

export default InputField;

